import { memo, useRef, useState } from 'react';
import MIcon from '../m-icon/MIcon';
import { useClickOutside } from '../../../hooks/useClickOutside';

const LangSwitcher = ({
                          currentLang = "RU",
                          classNameWrapper,
                          classNameCurrent,
                          classNameDropDown,
                          setCurrentLang = (str) => {},
                          options = []
                      }) => {

    const [isOpen, setIsOpen] = useState(false);
    const onHandleClick = (e) => {
        e.stopPropagation();
        setIsOpen(prev=>!prev)
    }
    const onHandleLanguageChange = (str) => {
        setCurrentLang(str)
        setIsOpen(false)
    }

    const ref = useRef(null);

    useClickOutside(ref, () => {
        setIsOpen(false);
    });
    return (
      <div
        className={`${classNameWrapper} cursor-pointer font-medium`}
        onClick={onHandleClick}
        ref={ref}
      >
          <div
            className={`flex items-center gap-1 ${classNameCurrent}`}
          >
              <div
                className={"underline relative"}
              >
                  {currentLang}

                  {isOpen && (
                    <div
                      className={`absolute ${classNameDropDown} left-1/2 translate-y-[20px] translate-x-[-50%] z-50 cursor-default p-4 rounded-lg`}
                      onClick={e=>e.stopPropagation()}
                    >
                        {options.map((item, index) => (
                          <p
                            key={item.value}
                            className={`mb-1 cursor-pointer ${currentLang===item.name && "font-bold"}`}
                            onClick={()=>onHandleLanguageChange(item.value)}
                          >
                              {item.name}
                          </p>
                        ))}
                    </div>
                  )}
              </div>
              <MIcon type={'arrowDown'} className={"cursor-pointer"}/>
          </div>
      </div>
    )
}

export default memo(LangSwitcher);